<template>
  <div>
    <UCPreload :show="showPreloadRecords" />
    <div class="">
      <div class="content-tabla-marcajes__list">
        <div
          v-for="(resumen, index) in resumenDeActividades"
          :key="index"
          class="item-content-tabla-marcajes selectable"
          @click="ShowDetails(resumen)"
        >
          <span class="color-blue padding-left">
            {{ TextMaximumLength(resumen.ActividadProduccion.Nombre, 30) }}
          </span>
          <div>
            <span class="padding-right item-text-x2">
              {{ GetHoursAndMinutes(resumen.TotalTiempo) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!----- Popup MArcajes de la actividad seleccionada ---->
    <f7-popup
      class=""
      :opened="popupMarcajesActividadSeleccionada"
      @popup:closed="popupMarcajesActividadSeleccionada = false"
    >
      <f7-page v-if="popupMarcajesActividadSeleccionada">
        <f7-navbar
          class="at-navbar secondary-navbar"
          title="Resumen de Actividad"
        >
          <f7-nav-right>
            <f7-link
              icon="icon-close"
              @click="popupMarcajesActividadSeleccionada = false"
            />
          </f7-nav-right>
        </f7-navbar>

        <!-- Registros de Marcajes -->
        <f7-block class="no-padding">
          <div
            v-if="resumenDeActividadSeleccionado != null"
            class="content-tabla-marcajes"
          >
            <div
              v-for="marcaje in resumenDeActividadSeleccionado.Marcajes"
              :key="marcaje.Id"
              class="content-tabla-marcajes__list"
            >
              <div class="item-content-tabla-marcajes">
                <span>
                  {{ TextMaximumLength(marcaje.ActividadProduccion.Nombre, 30) }}
                </span>
                <div>
                  <span>
                    {{ FormatearDiaMesAno(marcaje.FechaHora) }}
                    {{ FormatHoursAndMinutes(marcaje.FechaHora) }}
                  </span>
                </div>
              </div>
            </div> <!-- Fin registro -->
          </div>

          <div class="content-tabla-marcajes">
            <div class="content-tabla-marcajes__total">
              <span> TOTAL </span>
              <span>
                {{ GetHoursAndMinutes(resumenDeActividadSeleccionado.TotalTiempo) }}
              </span>
            </div>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDateTimeSupport, HiStringSupport } from '@/js/common/HIConversionSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp from '@/js/services/APIErp';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';

export default {
  name: 'PCActivityWorker',
  components: {
    UCPreload,
  },
  props: {
    selectedWorker: { type: Object, default: null },
  },
  data() {
    return {
      dateOfQuery: null,
      showPreloadRecords: false,
      resumenDeActividades: [],
      popupMarcajesActividadSeleccionada: false,

    };
  },
  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.dateOfQuery = new Date();
    },

    /**
     * @public
     * @returns {void}
     */
    UpdateRecordsByActivityGroup(date) {
      Log(this, this.UpdateRecordsByActivityGroup.name);
      this.resumenDeActividades = [];
      if (date === undefined) {
        HiNotification.Toast('Es necesario establecer una fecha');
        return;
      }
      this.dateOfQuery = date;
      this.GetRecordsByActivityGroup();
    },

    ShowDetails(resumen) {
      Log(this, this.ShowDetails.name);
      this.resumenDeActividadSeleccionado = resumen;
      this.popupMarcajesActividadSeleccionada = true;
    },

    TextMaximumLength(cadena, longitudMaxima) {
      return HiStringSupport.TextMaximumLength(cadena, longitudMaxima);
    },

    FormatearDiaMesAno(stringDateTime) {
      return HiDateTimeSupport.FormatDateTime(stringDateTime, 'DD/MM/YY');
    },

    FormatHoursAndMinutes(stringDateTime) {
      return HiDateTimeSupport.FormatDateTime(stringDateTime, 'HH:mm');
    },

    GetHoursAndMinutes(totalMinutos) {
      return HiDateTimeSupport.GetHoursAndMinutes(totalMinutos);
    },

    GetRecordsByActivityGroup() {
      Log(this, this.GetRecordsByActivityGroup.name);
      if (this.selectedWorker === null || this.dateOfQuery === null) {
        return;
      }
      const self = this;
      self.showPreloadRecords = true;
      APIErp.callRecordsByActivityGroup(this.selectedWorker.Id, HiDateTimeSupport.FormatDateTime(this.dateOfQuery, ''))
        .then((result) => {
          self.resumenDeActividades = result.data;
          self.showPreloadRecords = false;
        }).catch((error) => {
          self.showPreloadRecords = false;
          LogError(this, this.GetWorkerRecords.name, error);
        });
    },
  },
};
</script>

<style lang="scss">
.content-tabla-marcajes {
  overflow: scroll;
  position: relative;
  max-height: 100%;

  &__total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 15px;

    span {
      color: var(--his-oliva);
      font-size: 18px;
      font-weight: 500;
      line-height: 21px;
    }
  }
}
</style>
